/*
  HEIST DRAWER v2 (2026-10-14). Companion to snippets/heist-drawer-lines.liquid.

  WHAT IT OWNS: the +/- steppers, Remove, "Switch to Autoship", "Make it 3 bags", and
  window.HeistDrawer.pending() which the buy box calls so the drawer opens the instant a
  shopper taps, instead of after the add returns.

  THE ONE RULE: Autoship is priced per bag by the plan matching the TOTAL Autoship bags (1, 2,
  3, 4+). Any change to an Autoship quantity therefore re-plans EVERY Autoship line. The old
  drawer removed its steppers because a quantity change left the plan behind (the shopper
  silently paid the wrong tier). Everything below exists to keep plan and bag count in step.

  ORDER OF WRITES: one snapshot, then /cart/change.js by LINE NUMBER from the last line to the
  first. A plan change rewrites the line key and can merge two lines, which renumbers lines
  AFTER it - never before it - so walking backwards keeps every remaining index valid. Only
  the final write asks for the drawer markup.
*/
(function () {
  if (window.HeistDrawer) return;

  var FALLBACK_TIERS = "692936343874,692936540482,692936737090,692936933698";

  function root() { return document.querySelector("#cart-drawer [data-heist-drawer]"); }
  function tiers() {
    var r = root();
    return String((r && r.dataset.tierPlans) || FALLBACK_TIERS).split(",").map(Number);
  }
  function planFor(bags) {
    var t = tiers();
    return t[Math.min(Math.max(bags, 1), t.length) - 1];
  }
  function sectionId() {
    var el = document.querySelector("cart-items-component");
    return (el && el.dataset.sectionId) || "cart-drawer-section";
  }
  function json(url, body) {
    return fetch(url, {
      method: body ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  /* Same swap the buy box uses, so every writer leaves identical markup behind. */
  function swap(res) {
    var id = sectionId();
    if (!res || !res.sections || !res.sections[id]) return false;
    var doc = new DOMParser().parseFromString(res.sections[id], "text/html");
    var sels = ["cart-items-component", ".cart-drawer__inner"];
    for (var i = 0; i < sels.length; i++) {
      var next = doc.querySelector(sels[i]);
      var cur = document.querySelector("#cart-drawer " + sels[i]) || document.querySelector(sels[i]);
      if (next && cur) { cur.replaceWith(next); break; }
    }
    cancel();
    ["cart:update", "cart-updated"].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
    });
    return true;
  }
  function refresh() {
    return json("/?sections=" + encodeURIComponent(sectionId()))
      .then(function (s) { swap({ sections: s }); })
      .catch(function () {});
  }

  function isTier(item, tset) {
    var a = item.selling_plan_allocation;
    return !!(a && tset[a.selling_plan.id]);
  }
  function managed(item, tset) {
    if (item.final_line_price <= 0) return false;           // gifts are never touched here
    return !item.selling_plan_allocation || isTier(item, tset);  // prepaid / legacy plans left alone
  }

  /*
    snapshot(): the managed lines straight from the rendered drawer, so a tap costs one write,
    not a read and a write. The markup is the cart as of the last render, and every write swaps
    fresh markup in, so it cannot drift. Falls back to /cart.js if the drawer has no lines.
  */
  function snapshot() {
    var rows = document.querySelectorAll("#cart-drawer [data-heist-drawer] [data-hd-line]");
    if (!rows.length) return null;
    var out = [];
    rows.forEach(function (li) {
      var sub = li.dataset.sub;
      if (sub !== "tier" && sub !== "none") return;            // prepaid / legacy plans left alone
      var qty = parseInt(li.dataset.qty, 10) || 0;
      out.push({
        el: li, key: li.dataset.key, line: parseInt(li.dataset.hdLine, 10), qty: qty,
        mode: sub, was: { qty: qty, plan: li.dataset.plan ? Number(li.dataset.plan) : null }
      });
    });
    return out;
  }
  function snapshotFromCart(tset) {
    return json("/cart.js").then(function (cart) {
      var lines = [];
      (cart.items || []).forEach(function (it, i) {
        if (!managed(it, tset)) return;
        lines.push({
          key: it.key, line: i + 1, qty: it.quantity, mode: isTier(it, tset) ? "tier" : "none",
          was: { qty: it.quantity, plan: it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.id : null }
        });
      });
      return lines;
    });
  }

  function fmt(cents) {
    return "$" + (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function tierPrice(bags) {
    var r = root();
    var list = String((r && r.dataset.tierPrices) || "2995,2450,2300,2225").split(",").map(Number);
    return list[Math.min(Math.max(bags, 1), list.length) - 1];
  }

  /* INSTANT REPAINT. Prices, bag counts and the checkout total move on tap from the known tier
     prices; the real cart lands a beat later and replaces all of it. Never the source of truth. */
  function repaint(lines, subBags) {
    var each = subBags > 0 ? tierPrice(subBags) : 0;
    lines.forEach(function (l) {
      var li = l.el;
      if (!li) return;
      if (l.qty === 0) { li.classList.add("hd-line--leaving"); return; }
      var unit = l.mode === "tier" ? each : Number(li.dataset.unit) || 0;
      var price = li.querySelector("[data-hd-price]");
      if (price) price.textContent = fmt(unit * l.qty);
      li.dataset.liveCents = String(unit * l.qty);
      var cmp = li.querySelector("[data-hd-compare]");
      if (cmp) {
        var c = (Number(li.dataset.compare) || 0) * l.qty;
        cmp.textContent = fmt(c);
        cmp.hidden = !(c > unit * l.qty);
      }
      var bags = li.querySelector("[data-hd-bags]");
      if (bags) bags.textContent = l.qty + (l.qty === 1 ? " bag" : " bags");
      var out = li.querySelector("[data-hd-qty]");
      if (out) out.textContent = String(l.qty);
      var dec = li.querySelector('[data-hd-act="dec"]');
      if (dec) dec.disabled = l.qty <= 1;
    });
    /* Checkout button total: every paid line in the drawer, repainted or not. */
    var total = 0;
    document.querySelectorAll("#cart-drawer [data-hd-line]").forEach(function (li) {
      if (li.classList.contains("hd-line--leaving")) return;
      total += li.dataset.liveCents ? Number(li.dataset.liveCents)
        : (Number(li.dataset.unit) || 0) * (parseInt(li.dataset.qty, 10) || 0);
    });
    var btn = document.querySelector("#cart-drawer #checkout .button-text, #cart-drawer [name='checkout'] .button-text");
    /* The summary prints whole dollars without cents ("$89", "$101.99"); match it or it flickers. */
    var short = total % 100 === 0 ? fmt(total).replace(/\.00$/, "") : fmt(total);
    if (btn && total > 0) btn.textContent = btn.textContent.replace(/\$[\d,]+(\.\d{2})?/, short);
  }

  /*
    reconcile(edit): edit(lines) mutates {key, line, qty, mode}; this works out the plan for the
    resulting Autoship bag count, repaints instantly, and writes only what differs.
  */
  function reconcile(edit) {
    var tset = {};
    tiers().forEach(function (id) { tset[id] = true; });
    var snap = snapshot();
    return (snap ? Promise.resolve(snap) : snapshotFromCart(tset)).then(function (lines) {
      edit(lines);
      var subBags = lines.reduce(function (n, l) { return n + (l.mode === "tier" ? l.qty : 0); }, 0);
      var plan = subBags > 0 ? planFor(subBags) : null;
      repaint(lines, subBags);
      var ops = lines.filter(function (l) {
        var wantPlan = l.mode === "tier" && l.qty > 0 ? plan : null;
        return l.qty !== l.was.qty || (l.qty > 0 && wantPlan !== l.was.plan);
      }).map(function (l) {
        var body = { line: l.line, quantity: l.qty };
        if (l.qty > 0) body.selling_plan = l.mode === "tier" ? plan : null;
        return body;
      }).sort(function (a, b) { return b.line - a.line; });

      if (!ops.length) return refresh();
      return ops.reduce(function (chain, body, i) {
        return chain.then(function () {
          if (i === ops.length - 1) {
            body.sections = sectionId();
            body.sections_url = window.location.pathname;
          }
          return json("/cart/change.js", body);
        });
      }, Promise.resolve()).then(swap);
    });
  }

  function busy(on) {
    var r = root();
    if (r) r.classList.toggle("hd--busy", !!on);
  }

  function onClick(e) {
    var btn = e.target.closest("[data-hd-act]");
    if (!btn || !btn.closest("[data-heist-drawer]")) return;
    e.preventDefault();
    if (root() && root().classList.contains("hd--busy")) return;
    var li = btn.closest("[data-hd-line]");
    var key = li && li.dataset.key;
    var act = btn.dataset.hdAct;

    if (li && act === "dec" && (parseInt(li.dataset.qty, 10) || 1) <= 1) return;
    if (li && act === "remove") li.classList.add("hd-line--leaving");
    busy(true);

    reconcile(function (lines) {
      var me = lines.filter(function (l) { return l.key === key; })[0];
      if (act === "inc" && me) me.qty += 1;
      else if (act === "dec" && me) me.qty = Math.max(1, me.qty - 1);
      else if (act === "remove" && me) me.qty = 0;
      else if (act === "upgrade" && me) me.mode = "tier";
      else if (act === "topup") {
        var first = lines.filter(function (l) { return l.mode === "tier"; })[0];
        if (first) first.qty += parseInt(btn.dataset.need, 10) || 1;
      }
    })
      .catch(function () { return refresh(); })
      .then(function () { busy(false); });
  }
  document.addEventListener("click", onClick);

  /* ---------- instant open ---------- */

  function drawerEl() { return document.getElementById("cart-drawer"); }
  function drawerOpen() {
    var td = drawerEl();
    if (td && typeof td.isOpen === "boolean") return td.isOpen;
    return !!document.querySelector("#cart-drawer dialog[open]");
  }
  /* OPEN, NEVER TOGGLE. The cart icon is wired to #cart-drawer/toggle, so "clicking" it while the
     drawer is mid-open shuts it - measured as a drawer that opened on tap and closed a beat later.
     <theme-drawer> exposes open(); the click is only the fallback for a page where it has not
     upgraded yet. */
  function open() {
    if (drawerOpen()) return;
    var td = drawerEl();
    if (td && typeof td.open === "function") { try { td.open(); return; } catch (e) {} }
    var opener =
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector(".heist-cart") ||
      document.querySelector("[data-cart-drawer-open], cart-drawer-opener button");
    if (opener && opener.click) opener.click();
  }

  /* HOLD IT OPEN WHILE AN ADD IS IN FLIGHT. The theme force-closes the drawer once per page
     load (so it never flashes open on arrival), and on a slow load that close lands AFTER a fast
     shopper has already tapped. While a placeholder row is showing, a close is undone. */
  var holdUntil = 0;
  function guard() {
    var td = drawerEl();
    if (!td || td.__hdGuard) return;
    td.__hdGuard = true;
    var reopen = function () {
      if (Date.now() < holdUntil && document.querySelector("[data-hd-pending]")) {
        setTimeout(open, 0);
      }
    };
    td.addEventListener("theme-drawer:close", reopen);
    var dlg = td.querySelector("dialog");
    if (dlg) dlg.addEventListener("close", reopen);
  }

  /*
    pending(label): open the drawer NOW with a placeholder row for what is being added. The
    caller does the add and swaps the markup in when it returns; the placeholder disappears with
    the swap. If the add fails the caller calls HeistDrawer.cancel().
  */
  function pending(label) {
    holdUntil = Date.now() + 15000;
    guard();
    open();
    cancel();
    /* The row must live INSIDE <cart-items-component>: every writer replaces that element when
       the add lands, which is what removes the row. On an empty cart there is no list yet, so it
       goes at the top of the component itself - outside it, it would outlive the swap. */
    var host = document.querySelector("#cart-drawer .hd-lines");
    var comp = document.querySelector("#cart-drawer cart-items-component");
    var row = document.createElement(host ? "li" : "div");
    row.className = "hd-line hd-line--pending" + (host ? "" : " hd-line--solo");
    row.setAttribute("data-hd-pending", "");
    row.innerHTML =
      '<div class="hd-line__img hd-skel"></div><div class="hd-line__main">' +
      '<p class="hd-line__title">' + (label || "Adding to your cart") + "</p>" +
      '<p class="hd-line__meta">Adding to your cart&hellip;</p></div>';
    if (host) host.insertBefore(row, host.firstChild);
    else if (comp) {
      comp.querySelectorAll(".cart-drawer--empty, [data-cart-drawer-empty], .cart-items__wrapper--drawer-empty").forEach(function (n) { n.hidden = true; });
      comp.insertBefore(row, comp.firstChild);
    }
  }
  function cancel() {
    holdUntil = 0;
    document.querySelectorAll("[data-hd-pending]").forEach(function (n) { n.remove(); });
  }

  window.HeistDrawer = { pending: pending, cancel: cancel, open: open, refresh: refresh, reconcile: reconcile };
})();
